module.exports = __webpack_public_path__ + "img/vehicle_11.14fdaecc.svg";